import { render, staticRenderFns } from "./CompanyAndFormBtnBlock.vue?vue&type=template&id=50c2dd4e"
import script from "./CompanyAndFormBtnBlock.vue?vue&type=script&lang=js"
export * from "./CompanyAndFormBtnBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports